export enum Light {
  NATURAL = 'natural',
  MIXED = 'mixed',
  ARTIFICIAL = 'artificial',
}
